export var TagType;

(function (TagType) {
  TagType["Genre"] = "genre";
  TagType["Topic"] = "topic";
  TagType["Country"] = "country";
})(TagType || (TagType = {}));